<template>
  <div class="wrapper main">
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h3 class="title">
              Intro
            </h3>
            <p>
              TODO
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Intro',
  bodyClass: 'static-page',
  components: {

  },
  data() {
    return {}
  }
}
</script>
<style>
</style>
